import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {OrderHistoryAuditReportModel} from "./order-history-audit-report.model";
import {
    EntityGroupByReportCriteriaComponent
} from "../../../reports/common-report-criteria/entity-group-by-report-criteria/entity-group-by-report-criteria.component";

@Component({
    selector: "wbo-order-history-audit-report",
    templateUrl: "./order-history-audit-report.component.html",
    providers: [provideReportModel(OrderHistoryAuditReportModel)]
})
export class OrderHistoryAuditReportComponent extends AbstractReportPage {

    constructor(public model: OrderHistoryAuditReportModel) {
        super();
    }

    get showOutletOption(): boolean {
        return this.model.data.reportType !== EntityGroupByReportCriteriaComponent.PRODUCT_VALUE;
    }
}
